import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBackward, faForward } from "@fortawesome/free-solid-svg-icons";
import "./AuditPagination.css";

const AuditPagination = ({
  currentCursor,
  nextCursor,
  onNavigate,
  loading,
  totalItems,
  limit,
  searchData,
  showPagination = true,
}) => {
  const [prevKeys, setPrevKeys] = useState([]);

  useEffect(() => {
    if (!currentCursor) setPrevKeys([]);
  }, [currentCursor]);

  const handleNext = () => {
    if (!nextCursor || loading) return;
    setPrevKeys((prev) => [...prev, currentCursor]);
    onNavigate(nextCursor, searchData);
  };

  const handlePrev = () => {
    if (prevKeys.length === 0 || loading) return;
    const newPrev = [...prevKeys];
    const prevCursor = newPrev.pop();
    setPrevKeys(newPrev);
    onNavigate(prevCursor, searchData);
  };

  const currentPage = prevKeys.length + 1;
  const totalPages = totalItems && limit ? Math.ceil(totalItems / limit) : null;

  const startItem = totalItems && limit ? (currentPage - 1) * limit + 1 : null;
  const endItem =
    totalItems && limit ? Math.min(totalItems, currentPage * limit) : null;

  if (!totalItems && !nextCursor && !showPagination) return null;

  return (
    totalItems > 0 &&
    showPagination && (
      <div className="pagination-controls-container">
        <div className="pagination-controls">
          <span className="pagination-text">
            Items {startItem ?? "-"}-{endItem ?? "-"} of {totalItems}
          </span>

          {totalPages > 1 && (
            <>
              <Button
                onClick={handlePrev}
                disabled={prevKeys.length === 0 || loading}
                className="btn-transperant"
              >
                <FontAwesomeIcon icon={faBackward} />
              </Button>

              <span className="pagination-text">
                Page {currentPage} of {totalPages}
              </span>

              <Button
                onClick={handleNext}
                disabled={!nextCursor || loading}
                className="btn-transperant"
              >
                <FontAwesomeIcon icon={faForward} />
              </Button>
            </>
          )}
        </div>
      </div>
    )
  );
};

export default AuditPagination;
